import React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/swiper.scss';
import SwiperCore, { Autoplay } from 'swiper';
import i18n from "../../../i18nextInitiator";
SwiperCore.use([Autoplay]);

/**
 * translate function.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');

/**
 * JSS make styles.
 * @type {(props?: any) => ClassNameMap<"waitingText">}
 */
const useStyles = makeStyles((theme)=>({
    root: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.main,
        borderRadius: ".8rem",
        padding: "1rem",
        marginBottom: "1rem"
    },
    messageText: {
        color: theme.palette.text.primary
    }
}));

const IntroMessageBox = (props) => {
    const classes = useStyles()

    return <Paper className={classes.root} elevation={0} variant={"outlined"}>
        <Grid container>
            <Grid>
                <Typography variant={"h2"}>“</Typography>
            </Grid>
            <Grid item xs={11}>
                <Grid container direction={"row"}>
                    <Grid item xs={12}>
                        <Typography>{t(`intro-messages.title`)}</Typography>
                    </Grid>
                    <Grid item xs={12} className={classes.messageText}>
                        <Swiper autoplay={{delay: 6000}} spaceBetween={100}
                                slidesPerView={1}>
                            {
                                Array(9).fill("intro-messages.messages").map((item, index) => {
                                    return <SwiperSlide key={index}>
                                        <Typography>{t(`${item}.${index}`)}</Typography>
                                    </SwiperSlide>
                                })
                            }
                        </Swiper>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    </Paper>
}
export default IntroMessageBox